import OCRDocumentAPI from '../../../api/ocr/OCRDocumentAPI.js';

const state = {
  used: 0,
  limit: undefined,
  limitReached: false,
};

const getters = {
  limitReached() {
    return state.limitReached || (state.limit !== undefined && state.used >= state.limit);
  },
};

const actions = {
  obtainLimit({ commit }) {
    return OCRDocumentAPI.getLimit()
      .then(({ data }) => {
        commit('setLimit', data.limit || undefined);
        commit('setLimitReached', data.ocrLimitReached);
      });
  },
};

const mutations = {
  setUsed(state, value) {
    state.used = value;
  },
  setLimit(state, value) {
    state.limit = value;
  },
  setLimitReached(state, value) {
    state.limitReached = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};